export const REVIEW_ENV_NAME = {
    approved_title: 'Transfer Completed',
    approved_subtitle: 'Your data has been uploaded.',
    reject_title: 'Transfer Rejected',
    reject_subtitle: 'Your data has been rejected..',
  };
